import { apiClient } from "@/lib/apiClient";

/**
 * Fetch client phone autocomplete suggestions from backend.
 * @param phoneStart - The starting digits of the phone (minimum 3 digits).
 * @returns Promise resolving to array of { id, displayName, phone }
 */
export async function fetchClientPhoneAutocomplete(phoneStart: string): Promise<Array<{ id: string, displayName: string, phone: string, phoneCode: string, email?: string }>> {
  if (!phoneStart || phoneStart.length < 3) return [];
  const { data } = await apiClient.get(`/api/v1/admin-autocomplete/company/phone/${encodeURIComponent(phoneStart)}`);
  if (!Array.isArray(data)) return [];
  return data.map((item: any) => ({
    id: item.id,
    displayName: item.display_name || item.fullname || "",
    phone: item.phone || item.value || "",
    phoneCode: item.phone_code || "375",
    email: item.email || "",
  }));
}
